import { IFaqs } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

interface IFaqsState {
  order: Partial<IFaqs>[]
}

const adminGatewayResourcePath: string = '/website-api/sites/:param/faqs';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

const base = new StoreBaseImplementation<IFaqs>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced, // 'faqs/'

  state: {
    ...base.state,
    order: {} as IFaqsState,
  },

  getters: {
    ...base.getters,
    getOrder(state: IFaqsState) {
      return state.order;
    },
  },

  mutations: {
    ...base.mutations,
    setOrder(state: IFaqsState, payload: Partial<IFaqs>[]) {
      state.order = payload;
    },
  },

  actions: {
    ...base.actions,
  },
};
